/* This file was automatically generated - please modify the template not this file! */

import * as React from "react";
import { connect } from "react-redux";
import { ConfirmedReasonButton } from "@teamprevent/common/confirmedButton/ConfirmedReasonButton";

import { ThunkDispatch } from "redux-thunk";

import { cancelOhCase } from "../actions";
import { OhCase } from "../model";
import { CurrentUser } from "../../../auth";
import { ApplicationState } from "../../../applicationState";
import { OhCaseAuthorizer } from "../OhCaseAuthorizer";

type AllProps = OwnProps & StateProps & DispatchProps;

interface OwnProps {
    redirectUrl: string;
    ohCase: OhCase;
}

interface StateProps {
    currentUser: CurrentUser;
}

interface DispatchProps {
    cancel: (caseId: string, confirmationText: string, redirectUrl: string) => void;
}

export class CancelButton extends React.Component<AllProps> {
    public render() {
        if (!OhCaseAuthorizer.isAuthorizedToUpdate(this.props.ohCase, this.props.currentUser)) {
            return null;
        }

        return (
            <ConfirmedReasonButton
                negative
                icon="delete"
                content="Cancel Case"
                onSubmit={(notes) => this.props.cancel(this.props.ohCase.id, notes, this.props.redirectUrl)}
                // eslint-disable-next-line max-len
                promptText="Are you sure you want to cancel the case? This will cancel any appointments and close the case. No further action will be taken. The employee will be notified that the case has been cancelled."
                reasonPromptText="Please enter a reason for cancelling the case."
                headingText="Cancel Case"
            />);
    }
}

function mapStateToProps(state: ApplicationState): StateProps {
    return {
        currentUser: state.currentUser
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<void, undefined, any>): DispatchProps {
    return {
        cancel: (caseId: string, confirmationText: string, redirectUrl: string) => dispatch(cancelOhCase(caseId, confirmationText, redirectUrl))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CancelButton);
